import { render, staticRenderFns } from "./MdtInputTags.vue?vue&type=template&id=992c2e10&scoped=true"
import script from "./MdtInputTags.vue?vue&type=script&lang=js"
export * from "./MdtInputTags.vue?vue&type=script&lang=js"
import style0 from "./MdtInputTags.vue?vue&type=style&index=0&id=992c2e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992c2e10",
  null
  
)

export default component.exports